import { render, staticRenderFns } from "./SwitchTableColumn.vue?vue&type=template&id=676bcd09&"
import script from "./SwitchTableColumn.vue?vue&type=script&lang=js&"
export * from "./SwitchTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports